import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useDuplicateCheckWizardStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: {
        paddingTop: `13px`
      }
    }),
    []
  );
}
